import { AsyncPageRender } from '@components/AsyncComponent';
import { ProtectedRoute } from '@components/Layout/ProtectedRoute';
import { pageModule } from '@components/pageModule';
import { Route } from '@packages/router/lib/route';

export const routes = {
    Index: AsyncPageRender(() => pageModule(import('./Index'))),
};

function Router() {
    return (
        <>
            <Route name={'PromoCodes.List'} exact path={'/promo-codes/:tab'} component={ProtectedRoute(routes.Index)} />
        </>
    );
}

export default Router;
